module.exports = __webpack_public_path__ + "25.7661d9cd.png";